import React from 'react';
import PropTypes from 'prop-types';

import LocationBlock from '../../LocationSearch/LocationBlock';

const LOCATION_BLOCK_NAME = 'filter block'; // DON'T CHANGE THE VALUE, the format of value is due to analytics purposes

export default function FilterLocationSearch(props) {

  const classes = ['dc-filter-location-search'];

  if (props.mobileOrTablet) {
    classes.push('dc-filter-location-search-mobile-and-tablet');
  } else {
    classes.push('dc-filter-location-search-desktop');
  }

  return (
    <div className={classes.join(' ')}>
      <LocationBlock name={LOCATION_BLOCK_NAME} />
    </div>
  );
}

FilterLocationSearch.displayName = 'FilterLocationSearch';

FilterLocationSearch.propTypes = {
  mobileOrTablet: PropTypes.bool
};

FilterLocationSearch.defaultProps = {
  mobileOrTablet: false
};
